import type { TRootState } from '../reducers';
import type { ISiteItem } from '../reducers/sites';

export const selectSites = (state: TRootState): ISiteItem[] => {
  return state.sites?.sites ?? [];
};

export const selectSelectedSite = (state: TRootState): ISiteItem | null => {
  return state.sites?.selectedSite ?? null;
};

export const selectSitesIsLoading = (state: TRootState): boolean => {
  return state.sites?.isLoading ?? false;
};

export const selectSitesHasError = (state: TRootState): boolean => {
  return state.sites?.hasError ?? false;
};

export const selectSitesHasFetched = (state: TRootState): boolean => {
  return state.sites?.hasFetched ?? false;
};
